import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { IFaxFolder } from "src/app/models/fax/fax-folder";
import { IFaxRule } from "src/app/models/fax/fax-rule";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-delete-fax-rule-modal",
  templateUrl: "./delete-fax-rule-modal.component.html",
  styleUrls: ["./delete-fax-rule-modal.component.scss"],
})
export class DeleteFaxRuleModalComponent {
  @Input() rule: IFaxRule | null = null;
  @Input() folders: IFaxFolder[] = [];

  @Output() close = new EventEmitter();
  @Output() submit = new EventEmitter();

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.DeleteFaxRule;
  }

  get ruleDescription() {
    if (!this.rule) {
      return "";
    }

    const folderName = this.folders.find(folder => folder.id === this.rule.folderId)?.name ?? this.rule.folderId;

    return `${this.rule.triggerOn}: ${this.rule.direction} ${this.rule.trackingFaxNumber} - ${folderName}`;
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }

  onSubmitClick() {
    this._modalService.closeModal();
    this.submit.emit();
  }
}
